import { ListPerson } from "../../List/schema/list";
import { isDummyProspect } from "../../List/utils/columns/dummyProspect";

import { resolveSelectedCampaignConfig } from "./resolveSelectedCampaignConfig";

/** A lead Compose's "Send Selected" will schedule, with the campaign it resolves to. */
export interface ComposeSendItem {
	prospect: ListPerson;
	campaignId: string;
}

/**
 * The leads a Compose send schedules, each with its campaign. Placeholder rows ("SELECT" / "Person
 * not found") can never be sent to — their checkbox is hidden, but a stale or forced selection is
 * dropped here too — and so is an id no longer in the loaded inbox.
 */
export const resolveComposeSendItems = (
	selectedIds: number[],
	inbox: ListPerson[]
): ComposeSendItem[] =>
	selectedIds
		.map((id) => inbox.find((prospect) => prospect.id === id))
		.filter(
			(prospect): prospect is ListPerson => prospect !== undefined && !isDummyProspect(prospect)
		)
		.map((prospect) => ({
			prospect,
			campaignId: resolveSelectedCampaignConfig(prospect)?.id || "",
		}));
